var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6339 8.37372C17.0804 7.92727 17.0804 7.20223 16.6339 6.75577L10.9193 1.04117C10.4729 0.594716 9.74781 0.594716 9.30136 1.04117C8.8549 1.48762 8.8549 2.21266 9.30136 2.65912L13.0694 6.42361H2.11167C1.47949 6.42361 0.96875 6.93436 0.96875 7.56653C0.96875 8.19871 1.47949 8.70945 2.11167 8.70945H13.0659L9.30493 12.474C8.85848 12.9204 8.85848 13.6454 9.30493 14.0919C9.75138 14.5384 10.4764 14.5384 10.9229 14.0919L16.6375 8.37729L16.6339 8.37372Z",
    fill: "#0D6E89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.f8fd3c64e4e60b16f14026ec8b990005.svg";
export { ForwardRef as ReactComponent };